/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-alert:has([slot='content'])::part(_content) {
  display: block;
}

nve-alert-group:not(:has(nve-alert)),
nve-alert-group:not(:has(nve-alert:not([hidden]))) {
  display: none;
}
